import React from "react";
import Skeleton from "../../../components/ui/Skeleton";
import { SectionTitle, ProductListPad } from "../styles";
import { Row, Info, ThumbWrap } from "./ProductCard.styles";

interface StoreSkeletonProps {
  /** Quantidade de grupos fantasma (cada um com 3 produtos). */
  groups?: number;
  /** Inclui um bloco de cabeçalho (hero + nome da loja) acima da lista. */
  withHeader?: boolean;
}

/**
 * Placeholder com shimmer no formato da lista de produtos, exibido enquanto
 * grupos/produtos carregam — substitui o antigo "Carregando..." em modal.
 */
export default function StoreSkeleton({
  groups = 2,
  withHeader = false,
}: StoreSkeletonProps) {
  return (
    <div data-testid="store-skeleton">
      {withHeader && (
        <div style={{ padding: "16px 16px 4px" }}>
          <Skeleton height="132px" radius={22} />
          <Skeleton width="60%" height="22px" style={{ marginTop: 14 }} />
          <Skeleton width="40%" height="14px" style={{ marginTop: 8 }} />
        </div>
      )}
      {Array.from({ length: groups }).map((_, g) => (
        <div key={g}>
          <SectionTitle>
            <Skeleton width="140px" height="20px" />
          </SectionTitle>
          <ProductListPad>
            {Array.from({ length: 3 }).map((_, i) => (
              <Row key={i} style={{ cursor: "default" }}>
                <Info>
                  <Skeleton width="70%" height="16px" />
                  <Skeleton width="95%" height="12px" style={{ marginTop: 8 }} />
                  <Skeleton width="55%" height="12px" style={{ marginTop: 5 }} />
                  <Skeleton width="80px" height="16px" style={{ marginTop: 11 }} />
                </Info>
                <ThumbWrap>
                  <Skeleton width="88px" height="88px" radius={16} />
                </ThumbWrap>
              </Row>
            ))}
          </ProductListPad>
        </div>
      ))}
    </div>
  );
}
